(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["custom-banner-collection-slider"] && !window.DesignMode) return;
  try {
    
  // form a brands slider with slick
    $('.test-responsive').slick({
    slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 1500,
          arrows: true,
          dots: false,
          pauseOnHover: false,
        prevArrow:'<button type="button" class="slick-prev"></button>',
    nextArrow:'<button type="button" class="slick-next"></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll:5,
            infinite: true
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq"] && !window.DesignMode) return;
  try {
    

// jQuery('.tab').each(function(key, value){
//   jQuery(this).attr('data-id', key);
// });

// jQuery('.tab-content').each(function(key, value){
//   jQuery(this).attr('data-id', key);
// });
  
  
const tabs = document.querySelectorAll(".tab");
const tabContent = document.querySelectorAll(".faq-tabs .tab-content");

let tabNo = 0;
let contentNo = 0;

tabs.forEach((tab) => {
  tab.dataset.id = tabNo;
  tabNo++;
  tab.addEventListener("click", function () {
    tabs.forEach((tab) => {
      tab.classList.remove("active");
      tab.classList.add("non-active");
    });
    this.classList.remove("non-active");
    this.classList.add("active");
    tabContent.forEach((content) => {      
      content.classList.add("hidden");
      if (content.dataset.id === tab.dataset.id) {
          content.classList.remove("hidden");
      }
    });
  });
});

tabContent.forEach((content) => {
  content.dataset.id = contentNo;
  contentNo++;
});
  

  } catch(e) { console.error(e); }
})();

})();
